import { ComponentProps } from "react";
import {
  containerRowMaxWidth,
  palette,
  spaceUnit,
} from "@dbn/omnichannel-design-system-g4p/lib/styleConstants";
import { Logo } from "./Logo";
import * as classes from "./HeaderTouchScreenA11Y.css";
import { option } from "fp-ts";
import { constNull, pipe } from "fp-ts/function";
import { Space, Box, Heading } from "@dbn/omnichannel-design-system-g4p";
import { LogoOpen } from "./LogoOpen";
import { HeaderCZA11Y } from "./HeaderCZA11Y";

type Props = Pick<ComponentProps<typeof HeaderCZA11Y>, "title">;

export function HeaderTouchScreenA11Y(props: Props) {
  return (
    <Box component="header" height={112} className={classes.header}>
      <Box grow shrink />
      <Box
        style={{
          width: "100%",
          maxWidth: containerRowMaxWidth,
          justifyContent: "space-around",
          margin: "0 auto",
        }}
      >
        <Box
          shrink
          hAlignContent="left"
          vAlignContent="center"
          className={classes.logoArea}
        >
          <Logo height={36} />
          <Space units={4} />
          <LogoOpen height={36} />
        </Box>
        <Box
          grow
          hAlignContent="left"
          vAlignContent="center"
          style={{
            backgroundColor: palette.white,
            paddingLeft: 10 * spaceUnit,
          }}
        >
          {pipe(
            props.title,
            option.fold(constNull, title => (
              <Heading size="medium" weight="medium" color={palette.dark}>
                {title}
              </Heading>
            ))
          )}
        </Box>
      </Box>
      <Box grow shrink style={{ backgroundColor: palette.white }} />
    </Box>
  );
}
